import React from 'react';

export const CopyIcon = ({ ...restProps }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M10.667 13C10.667 13.2652 10.5616 13.5196 10.3741 13.7071C10.1866 13.8946 9.93221 14 9.66699 14H3.66699C3.40178 14 3.14742 13.8946 2.95989 13.7071C2.77235 13.5196 2.66699 13.2652 2.66699 13V5C2.66699 4.73478 2.77235 4.48043 2.95989 4.29289C3.14742 4.10536 3.40178 4 3.66699 4H5.33366"
      stroke="#717171"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M10.667 13V12" stroke="#717171" />
    <path
      d="M10.333 2H6.33301C6.06779 2 5.81344 2.10536 5.6259 2.29289C5.43836 2.48043 5.33301 2.73478 5.33301 3V11C5.33301 11.2652 5.43836 11.5196 5.6259 11.7071C5.81344 11.8946 6.06779 12 6.33301 12H12.333C12.5982 12 12.8526 11.8946 13.0401 11.7071C13.2277 11.5196 13.333 11.2652 13.333 11V5L10.333 2Z"
      stroke="#717171"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 2V5.33333H13.3333"
      stroke="#717171"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.333 7.33333H7.33301"
      stroke="#717171"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.333 9.33333H7.33301"
      stroke="#717171"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99967 5.33333H7.66634H7.33301"
      stroke="#717171"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default CopyIcon;
